import { supabase } from '../lib/supabase';

/**
 * Service for managing psychologist notification settings
 */
export const notificationSettingsService = {
  /**
   * Get notification settings for a psychologist
   * @param {string} psychologistId - Psychologist ID
   * @returns {Promise<Object>} Notification settings
   */
  async getSettings(psychologistId) {
    const { data, error } = await supabase?.from('psychologists')?.select(`
        notification_sound_enabled,
        whatsapp_reminder_hours,
        notify_new_appointment,
        notify_cancelled_appointment,
        notify_daily_appointments,
        public_page_enabled
      `)?.eq('id', psychologistId)?.single();

    if (error) throw error;

    // Convert snake_case to camelCase
    return {
      notificationSoundEnabled: data?.notification_sound_enabled,
      whatsappReminderHours: data?.whatsapp_reminder_hours,
      notifyNewAppointment: data?.notify_new_appointment,
      notifyCancelledAppointment: data?.notify_cancelled_appointment,
      notifyDailyAppointments: data?.notify_daily_appointments,
      publicPageEnabled: data?.public_page_enabled
    };
  },

  /**
   * Update notification settings for a psychologist
   * @param {string} psychologistId - Psychologist ID
   * @param {Object} settings - Settings to update
   * @returns {Promise<Object>} Updated settings
   */
  async updateSettings(psychologistId, settings) {
    // Convert camelCase to snake_case
    const dbSettings = {};
    
    if (settings?.notificationSoundEnabled !== undefined) {
      dbSettings.notification_sound_enabled = settings?.notificationSoundEnabled;
    }
    if (settings?.whatsappReminderHours !== undefined) {
      dbSettings.whatsapp_reminder_hours = settings?.whatsappReminderHours;
    }
    if (settings?.notifyNewAppointment !== undefined) {
      dbSettings.notify_new_appointment = settings?.notifyNewAppointment;
    }
    if (settings?.notifyCancelledAppointment !== undefined) {
      dbSettings.notify_cancelled_appointment = settings?.notifyCancelledAppointment;
    }
    if (settings?.notifyDailyAppointments !== undefined) {
      dbSettings.notify_daily_appointments = settings?.notifyDailyAppointments;
    }
    if (settings?.publicPageEnabled !== undefined) {
      dbSettings.public_page_enabled = settings?.publicPageEnabled;
    }

    const { data, error } = await supabase?.from('psychologists')?.update(dbSettings)?.eq('id', psychologistId)?.select(`
        notification_sound_enabled,
        whatsapp_reminder_hours,
        notify_new_appointment,
        notify_cancelled_appointment,
        notify_daily_appointments,
        public_page_enabled
      `)?.single();

    if (error) throw error;

    // Convert snake_case to camelCase
    return {
      notificationSoundEnabled: data?.notification_sound_enabled,
      whatsappReminderHours: data?.whatsapp_reminder_hours,
      notifyNewAppointment: data?.notify_new_appointment,
      notifyCancelledAppointment: data?.notify_cancelled_appointment,
      notifyDailyAppointments: data?.notify_daily_appointments,
      publicPageEnabled: data?.public_page_enabled
    };
  }
};